import { useSelector } from "react-redux";
import { loadWeather } from "../utils/utils";
import './TopBar.scss'
export default function TopBar(props) {
  const favuriteCity = useSelector(state => state.city.city)
  const weather = useSelector(state => state.weather.weather)


  if (!(favuriteCity.id in weather)) {
    loadWeather(favuriteCity)
  }

  return (
    <div className="topBar" >
      <div className="container">
        {
          favuriteCity ? 
            <>
              {
                weather[favuriteCity.id] ?
                  <>
                    {
                      favuriteCity.name + " | " + weather[favuriteCity.id].weather.current.temp + "°C | " +weather[favuriteCity.id].weather.current.weather[0].description
                    }
                  </>
                  :
                  <>
                    {
                      favuriteCity.name + " loading meteo"
                    }
                  </>
              }
            </>
            :
            <></>
        }
      </div>
    </div>
  )
}